import "./Portfolio.scss";

import Captio from "../../assets/preview-captio.png";
import CaptioIcon from "../../assets/Captio.png";
import CardioIcon from "../../assets/KardioLog_logo.png";
import FintechConnector from "../../assets/preview-fintechconnector.png";
import FintechIcon from "../../assets/Fintech.png";
import Kardiolog from "../../assets/preview-kardiolog.png";
import React from "react";

interface IProduct {
  name: string;
  description: string;
  images: string[];
  icon: string;
}

const Products: IProduct[] = [
  {
    name: "FinTech Connector",
    description:
      "Community application designed for the Fintech industry professionals.",
    images: [FintechConnector],
    icon: FintechIcon,
  },

  {
    name: "KardioLog App",
    description:
      "Healthtech application designed for users with diagnosed heart failure.",
    images: [Kardiolog],
    icon: CardioIcon,
  },
  {
    name: "Captio",
    description:
      "Peer to Peer video-chat  application with a real-time transcription. The product is designed for hearing-impaired patients",
    images: [Captio],
    icon: CaptioIcon,
  },
];

export const OurPortfolioEntre = () => {
  return (
    <div className="portfolio">
      <div className="container">
        <div className="header-our-portfolio">
          <h2>Our Portfolio</h2>
        </div>
        {Products.map((product: IProduct, index: number) => {
          return (
            <div className="product" key={index}>
              <div className="left-panel">
                <div className="content">
                  <div className="product-horizontal-menu">
                    <div className="app-name active">
                      {index >= 10 ? index + 1 : "0" + (index + 1)}
                      &nbsp;&nbsp;&nbsp;
                      {product.name}
                    </div>
                  </div>
                  <div className="app-description-entre">
                    <p>{product.description}</p>
                    <div className="app-description-entre__details-box">
                      <div className="box">
                        <div className="inner">
                          <img src={product.icon} style={{width: "70%"}} alt={"Portfolio icon"}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-panel">
                <div className="column">
                  <div className="circle" />
                  {product.images.length === 1 ? (
                    <ShowSingleImage
                      alt={product.name}
                      image={product.images[0]}
                    />
                  ) : (
                    <ShowDoubleImage
                      alt={product.name}
                      images={product.images}
                    />
                  )}
                </div>
              </div>
              <div className="product-horizontal-menu product-horizontal-menu--mobile">
                <div className="app-name active">{product.name}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ShowSingleImage = (props: {
  alt: string;
  image: string;
}): JSX.Element => {
  const image = props.image;
  const { alt } = props;
  return (
    <div className="portfolio-app-image">
      <img src={image} alt={alt} />
    </div>
  );
};

const ShowDoubleImage = (props: {
  alt: string;
  images: string[];
}): JSX.Element => {
  const firstImage = props.images[0];
  const secondImage = props.images[1];
  const { alt } = props;

  return (
    <div className="portfolio-app-image-alt">
      <img src={firstImage} alt={alt} />
      <img src={secondImage} alt={alt} />
    </div>
  );
};
